<template>
  <div>
    <v-card flat>
      <v-row class="py-0 my-0">
        <v-col cols="12" sm="6" class="pa-1">
          <v-row>
            <v-col cols="2">
              <v-btn fab dark small color="success" @click="exportOrderAndOffer('offer')" :loading="exportOfferLoading">
                <v-icon dark id="generateexcel">mdi-file-excel</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-card flat>
            <v-card-text class="py-0 my-0">
              <highcharts :options="offerChart" ref="offerChart"></highcharts>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" class="pa-1">
          <v-row>
            <v-col cols="2">
              <v-btn fab dark small color="success" @click="exportOrderAndOffer('order')" :loading="exportOrderLoading">
                <v-icon dark id="generateexcel">mdi-file-excel</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn-toggle mandatory color="primary" v-model="filterbasedon" rounded dense @change="getSalesOrOfferWidgetData">
                <v-btn value="week">{{ $t('message.common.week') }}</v-btn>
                <v-btn value="month">{{ $t('message.common.month') }}</v-btn>
                <v-btn value="year">{{ $t('message.common.year') }}</v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col cols="4">
              <v-autocomplete outlined dense hide-details :label="$t('message.deviations.responsible')" :items="listUsers" item-value="id" multiple item-text="fullname" v-model="responsibleids" @change="getSalesOrOfferWidgetData('offer')"></v-autocomplete>
            </v-col>
          </v-row>
          <v-card flat>
            <v-card-text class="py-0 my-0">
              <highcharts :options="salesChart" ref="salesChart"></highcharts>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" class="pa-1">
          <v-card flat>
            <v-card-text class="py-0 my-0">
              <highcharts :options="dgPercentageSalesChart" ref="dgPercentageSalesChart"></highcharts>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" class="pa-1">
          <v-card>
            <v-card-text class="pa-0">
              <v-sheet>
                <highcharts :options="turnOverData" ref="customerTurnOverChart"></highcharts>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-row>
      <v-col cols="12" class="pa-1">
        <v-card>
          <v-card-text class="pa-0">
            <v-sheet>
              <highcharts :options="customersData" ref="customerChart"></highcharts>
            </v-sheet>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-card flat color="transparent">
          <v-card-title class="py-1 px-0">{{ $t('message.turnoverReport.turnover') }}</v-card-title>
          <!-- <v-divider></v-divider> -->
          <v-card-text class="px-0">
            <turnover-report :turnoverDataList="turnoverDataList"></turnover-report>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      responsibleids: [],
      filterbasedon: 'week',
      listUsers: [],
      customersData: {},
      turnOverData: {},
      ordersData: {},
      turnoverDataList: [],
      offerFilterObj: {
        type: 'offer',
        timerange: 'month'
      },
      saleFilterObj: {
        type: 'order',
        timerange: 'month'
      },
      salesChart: {},
      dgPercentageSalesChart: {},
      offerChart: {
        chart: {
          height: 280,
          type: 'column'
        },
        title: {
          text: this.$t('message.order.order')
        },
        xAxis: {
          categories: [],
          title: {
            text: this.$t('message.layout.totalTurnoverPerResponsible')
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Verdi',
            align: 'high'
          },
          labels: {
            overflow: 'justify'
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.2f}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          x: -40,
          y: 80,
          floating: true,
          borderWidth: 1,
          backgroundColor: '#FFFFFF',
          shadow: true
        },
        credits: {
          enabled: false
        },
        series: []
      },
      exportOrderLoading: false,
      exportOfferLoading: false
    }
  },
  computed: {
    ...mapState(['listOfUsers']),
    timeRangeIems () {
      return [{
        text: this.$t('message.common.thisweek'),
        value: 'week'
      }, {
        text: this.$t('message.common.thismonth'),
        value: 'month'
      }, {
        text: this.$t('message.common.thisyear'),
        value: 'year'
      }, {
        text: this.$t('message.common.custom'),
        value: 'custom'
      }]
    },
    customerChart () {
      return {
        chart: {
          type: 'column',
          height: 280
        },
        title: {
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          min: 0,
          minPointLength: 0,
          title: {
            text: this.$t('message.orders.totalInvoiced')
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        tooltip: {
          pointFormat: '<b>{point.y}</b>'
        }
      }
    }
  },
  mounted () {
    this.$store.dispatch('getUsers').then(response => {
      this.setUsersFullname()
    })
    this.getDashboardData()
    this.getTurnoverData()
    this.getSalesOrOfferWidgetData()
  },
  components: {
    'turnover-report': () => import('@/components/Reports/TurnOverYearMonthViewReport.vue')
  },
  methods: {
    setUsersFullname () {
      let transformData = { merge: { list: ['firstname', 'lastname'], property: 'fullname' } }
      this.listUsers = this.$_formatListModel(this.listOfUsers, transformData)
    },
    getSalesOrOfferWidgetData () {
      let model = { filterbasedon: this.filterbasedon, responsibleids: this.responsibleids }
      this.$_executeApi('post', `dashboard/get_sales_offers_report`, model)
        .then((response) => {
          this.offerChart.series = [
            {
              name: `${this.$t('message.dashboard.last')} ${this.$t(`message.dashboard.${this.filterbasedon}`)}`,
              data: []

            }, {
              name: `${this.$t('message.dashboard.current')} ${this.$t(`message.dashboard.${this.filterbasedon}`)}`,
              data: []
            }
          ]
          this.salesChart = this.$formatter.cloneVariable(this.offerChart)
          this.salesChart.xAxis.categories = []
          this.offerChart.xAxis.categories = []
          this.offerChart.title.text = this.$t('message.layout.offer')
          this.salesChart.title.text = this.$t('message.orders.sold')
          response.data.offerresult.forEach((x, index) => {
            if (x.name) {
              this.offerChart.xAxis.categories.push(x.name)
              this.offerChart.series[0].data.push(x.lastvalue)
              this.offerChart.series[1].data.push(x.value)
            }
          })
          response.data.orderresult.forEach((x, index) => {
            if (x.name) {
              this.salesChart.xAxis.categories.push(x.name)
              this.salesChart.series[0].data.push(x.lastvalue)
              this.salesChart.series[1].data.push(x.value)
            }
          })

          // DG% Sales/Order Chart
          this.dgPercentageSalesChart = this.$formatter.cloneVariable(this.salesChart)
          this.dgPercentageSalesChart.series = [
            {
              name: `${this.$t('message.dashboard.last')} ${this.$t(`message.dashboard.${this.filterbasedon}`)}`,
              data: []
            }, {
              name: `${this.$t('message.dashboard.current')} ${this.$t(`message.dashboard.${this.filterbasedon}`)}`,
              data: []
            }
          ]
          this.dgPercentageSalesChart.xAxis.categories = []
          this.dgPercentageSalesChart.title.text = 'DG%'
          this.dgPercentageSalesChart.yAxis.title.text = 'DG%'
          if (response.data.dgpercentageorderresult) {
            response.data.dgpercentageorderresult.forEach((x, index) => {
              if (x.name) {
                this.dgPercentageSalesChart.xAxis.categories.push(x.name)
                this.dgPercentageSalesChart.series[0].data.push(x.lastvalue)
                this.dgPercentageSalesChart.series[1].data.push(x.value)
              }
            })
          }
        })
    },
    getDashboardData () {
      this.$_executeApi('get', 'dashboard/get_dashboard_resultsets')
        .then((response) => {
          const { topcustomers, turnoverthismonth } = response.data
          const getCustomerResults = []
          const getCustomerTurnOverResults = []
          topcustomers.map(x => {
            let customer = [x.name, x.value]
            getCustomerResults.push(customer)
          })

          let customer = [turnoverthismonth.name, turnoverthismonth.value]
          getCustomerTurnOverResults.push(customer)

          // var getMonthNames = orders.map(x => x.name)
          // var getStoreValue = orders.map(x => x.store)
          // var getWebValue = orders.map(x => x.web)
          // var orderResults = [{ name: this.$t('message.orders.store'), data: getStoreValue }, { name: this.$t('message.orders.web'), data: getWebValue }]

          let customerWrapper = this.getSeriesData(getCustomerResults)
          let customerTurnOverWrapper = this.getSeriesData(getCustomerTurnOverResults)
          var customerData = this.getChartData(this.$t('message.dashboard.topCustomers'), customerWrapper)
          customerData.tooltip = {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.2f}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          }
          this.customersData = customerData
          this.turnOverData = this.getChartData(this.$t('message.dashboard.turnOverMonth'), customerTurnOverWrapper)

          // var getOrderData = this.getChartData(this.$t('message.orders.storeWeb'), orderResults)
          // getOrderData.xAxis.categories = getMonthNames
          // getOrderData.tooltip = {
          //   headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          //   pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          //       '<td style="padding:0"><b>{point.y:.2f}</b></td></tr>',
          //   footerFormat: '</table>',
          //   shared: true,
          //   useHTML: true
          // }

          // getOrderData.yAxis.title.text = this.$t('message.orders.totalOrders')

          // this.ordersData = getOrderData
        })
    },
    getSeriesData (payload) {
      return [{
        name: this.$t('message.order.customer'),
        colorByPoint: true,
        data: payload,
        dataLabels: {
          enabled: true,
          rotation: -90,
          color: '#FFFFFF',
          align: 'right',
          format: '{point.y}',
          y: 10,
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif'
          }
        }
      }]
    },
    getChartData (title, series) {
      let data = this.$formatter.cloneVariable(this.customerChart)
      data.title.text = title
      data.series = series
      return data
    },
    getTurnoverData () {
      this.$_executeApi('get', 'dashboard/get_turnover_data')
        .then((response) => {
          if (response && response.data) this.turnoverDataList = response.data
        })
    },
    exportOrderAndOffer (type) {
      if (type === 'order') {
        this.exportOrderLoading = true
      } else {
        this.exportOfferLoading = true
      }
      let model = { filterbasedon: this.filterbasedon, responsibleids: this.responsibleids }
      let url = type === 'order' ? 'orders/generate_excel_order_dashboard' : 'orders/generate_excel_offer_dashboard'
      this.$_executeApi('post', url, model).then((response) => {
        if (response.data === 'no_data') {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.no_records') })
          this.exportOrderLoading = false
          this.exportOfferLoading = false
        } else {
          this.$_downloadExportedReport(response.data).finally(() => {
            this.exportOrderLoading = false
            this.exportOfferLoading = false
          })
        }
      })
    }
  }
}
</script>
